import React, { Component, PropTypes } from 'react';
import { ItemTypes } from '../constants';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { pointIcon } from '../reducers/point';

const pointSource = {
  beginDrag(props) {
    return {
      point: props.point,
    };
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
});

class UnpinnedPointItem extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    });
  }

  render() {
    const { point, connectDragSource, onDisplay, taskType } = this.props;

    const display = () => onDisplay(point);

    return connectDragSource(
      <div className="ui segment" onClick={display}>
        <img
          className="ui right spaced avatar image"
          src={pointIcon(point, taskType)}
          alt="Point"
        />
        <span>{point.number}</span>
      </div>
    );
  }
}

UnpinnedPointItem.propTypes = {
  point: PropTypes.object.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onDisplay: PropTypes.func.isRequired,
  taskType: PropTypes.func.isRequired,
};

export default DragSource(
  ItemTypes.POINT,
  pointSource,
  collect
)(UnpinnedPointItem);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/components/UnpinnedPointItem.js